"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Render the label for day of the week
var CalendarGrid = function CalendarGrid(_ref) {
  var TODAY = _ref.TODAY,
    selectedDate = _ref.selectedDate,
    currentMonth = _ref.currentMonth,
    currentYear = _ref.currentYear,
    getCalendarDates = _ref.getCalendarDates,
    gotoDate = _ref.gotoDate,
    enableDatesInPast = _ref.enableDatesInPast;
  // Render the label for day of the week
  var renderDayLabel = function renderDayLabel(day) {
    // Resolve the day of the week label from the WEEK_DAYS object map
    var dayLabel = _utils.WEEK_DAYS[day].toUpperCase();
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "calendar-cell calendar-day",
      key: dayLabel
    }, dayLabel[0]);
  };

  // Render a calendar date as returned from the calendar builder function
  var renderCalendarCell = function renderCalendarCell(data) {
    // Incoming date format [2020, "09", "28"]
    // [number, string, string]
    var parsedData = data.join("-");
    var cellDate = new Date(parsedData);

    // Check if calendar date is same day as TODAY
    var isToday = (0, _utils.isSameDay)(cellDate, TODAY);

    // Check if calendar date is same day as currently selected date
    var isCurrent = selectedDate && (0, _utils.isSameDay)(cellDate, selectedDate);

    // Check if calendar date is in the same month as the state month and year
    var inMonth = currentMonth && currentYear && (0, _utils.isSameMonth)(cellDate, new Date([currentYear, currentMonth, 1].join("-")));

    // Disable the button if it's in the past and selection of past dates is not enabled
    var isInPast = !isToday && cellDate.getTime() < TODAY.getTime();
    var isDisabled = !enableDatesInPast && isInPast;
    return /*#__PURE__*/_react.default.createElement("button", {
      key: (0, _utils.getDateISO)(cellDate),
      disabled: isDisabled,
      className: (0, _classnames.default)({
        "calendar-cell": true,
        "is-highlighted": isCurrent,
        "is-in-month": inMonth,
        "is-today": isToday
      }),
      onClick: function onClick() {
        return gotoDate(cellDate);
      },
      title: cellDate.toDateString()
    }, cellDate.getDate());
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-grid"
  }, Object.keys(_utils.WEEK_DAYS).map(renderDayLabel), getCalendarDates().map(function (day) {
    return renderCalendarCell(day);
  }));
};
var _default = CalendarGrid;
exports.default = _default;